import api from './api';
import { Course } from '../types';

export const courseService = {
  getCourses: async (page = 1, perPage = 10, categoryId?: number, status = 'published') => {
    const params: any = { page, per_page: perPage, status };
    if (categoryId) params.category_id = categoryId;
    
    const response = await api.get<{
      courses: Course[];
      total: number;
      page: number;
      per_page: number;
      pages: number;
    }>('/courses', { params });
    return response.data;
  },

  getCourse: async (id: number) => {
    const response = await api.get<{ course: Course }>(`/courses/${id}`);
    return response.data.course;
  },

  createCourse: async (courseData: Partial<Course> & { thumbnailFile?: File }) => {
    const formData = new FormData();
    
    if (courseData.thumbnailFile) {
      formData.append('thumbnail', courseData.thumbnailFile);
    }
    if (courseData.title) formData.append('title', courseData.title);
    if (courseData.description !== undefined) formData.append('description', courseData.description || '');
    if (courseData.thumbnail && !courseData.thumbnailFile) {
      formData.append('thumbnail', courseData.thumbnail);
    }
    if (courseData.price !== undefined) formData.append('price', courseData.price.toString());
    if (courseData.category_id !== undefined) formData.append('category_id', courseData.category_id.toString());
    if (courseData.level) formData.append('level', courseData.level);
    if (courseData.status) formData.append('status', courseData.status);
    if (courseData.instructor_id !== undefined) formData.append('instructor_id', courseData.instructor_id.toString());

    const response = await api.post<{ message: string; course: Course }>(
      '/courses',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  updateCourse: async (id: number, courseData: Partial<Course> & { thumbnailFile?: File }) => {
    const formData = new FormData();
    
    if (courseData.thumbnailFile) {
      formData.append('thumbnail', courseData.thumbnailFile);
    }
    if (courseData.title !== undefined) formData.append('title', courseData.title);
    if (courseData.description !== undefined) formData.append('description', courseData.description || '');
    if (courseData.thumbnail && !courseData.thumbnailFile) {
      formData.append('thumbnail', courseData.thumbnail);
    }
    if (courseData.price !== undefined) formData.append('price', courseData.price.toString());
    if (courseData.category_id !== undefined) {
      formData.append('category_id', courseData.category_id ? courseData.category_id.toString() : '');
    }
    if (courseData.level) formData.append('level', courseData.level);
    if (courseData.status) formData.append('status', courseData.status);
    if (courseData.instructor_id !== undefined) formData.append('instructor_id', courseData.instructor_id.toString());

    const response = await api.put<{ message: string; course: Course }>(
      `/courses/${id}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  deleteCourse: async (id: number) => {
    const response = await api.delete<{ message: string }>(`/courses/${id}`);
    return response.data;
  },
};

